import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';

export class WorkerUpdateTask extends GenericRequest {

    _request; // WorkerUpdateRequest

    constructor(request) {
        super(METHOD_POST, request.url());
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/update/worker-update/WorkerUpdateTask.js